import React, { Component } from 'react'
import PageHeaderWrapper from '../../components/PageHeaderWrapper'
import { TableComp } from 'sz-react-utils'
import moment from 'moment/moment'
import ListFollowUps from '../../components/_utils/listFollowUp'

import {
    Button,
    Card,
    notification,
    Tooltip,
    DatePicker,
    Row,
    Col
} from "antd";

import Request from '../../request'

import { connect } from 'react-redux'

import styles from '../Desk/claim/all/styles.less'
import LatestFollowUp from '../../components/_utils/latestFollowup'
import Settings from '../../components/_utils/settings'
import Payment from '../../components/_utils/payment'

import lodash from 'lodash'

import SMS from '../../components/communication/sms'
import WhatsAPPSMS from '../../components/communication/WhatsAppSms'
import EmailDrawer from '../../components/communication/emailDrawer'
import { Link } from 'react-router-dom'
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const deskLinks = {
    "Front Desk": '/desk/update-counselling',
    "Registration Desk": "/registration/fees",
    "Application Desk": "/desk/allApplication-desk/update",
    "Visa Desk": "/desk/getVisa",
    "Claim Desk": "/desk/getClaim"
}
let studentObj = {};
let userCheckBox = {}
let counsellingData = {}

const { RangePicker } = DatePicker;

let inquiryObj = {}

class SubmitFees extends Component {
    state = {
        count: 0,
        followDuesCount: 0,
        showFollowUp: false,
        showRecentInvoices: false,
        studentId: null,
        studentSearchId: '',
        allBranches: [],
        counsellorId: '',
        counsellors: [],
        recentInvoices: [],
        channelPartnerList: [],
        deskColor: null,
        paymentBalance: [{ label: 'Not Received', value: true },
        { label: 'Received', value: false }],
        ratingArr: ['Fit2Apply', 'Potential', 'Luke Warm', 'Cold', 'Dead'],
        leadSourceList: ['University', 'Channel Partner'],
        studentStatusList: ['Not Enrolled Yet', 'Ongoing', 'Max Commission Paid', 'Withdrawn - Bad Debts'],
        invoiceStatusList: ['To Be Invoiced', 'Invoice Processed-Term 1', 'Invoice Processed-Term 2', 'Invoice Processed-Term 3', 'Invoice Processed-Term 4', 'Invoice Processed-Term 5'],
        drawerTodayPastInvoices: true,
        showPayNow: false,
        isFollowUpOverdue: false,
        showSMS: false,
        showWhatsAppSms: false,
        showEmail: false,
        userCheckBox: {},
        time: null,
    }


    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }
    showSMS = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showSMS: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeSMS = () => {
        this.setState({ showSMS: false })
    }
    showWhatsAppSms = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return (item.isChecked === true ? item : false);
        })

        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showWhatsAppSms: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    closeWhatsSMS = () => {
        this.setState({ showWhatsAppSms: false })
    }
    closeEmail = () => {
        this.setState({ showEmail: false })
    }
    showEmail = () => {
        let userArr = lodash.filter(this.state.userCheckBox, (item) => {
            return item.isChecked
        })
        if (userArr && userArr.length) {
            counsellingData = {
                usersData: userArr
            }
            this.setState({ showEmail: true })
        } else {
            notification.error({
                message: 'Please select atleast 1 user.'
            })
        }
    }
    selectUser = (item, studentId) => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        if (cloneUserCheckBox[studentId] === undefined) {
            cloneUserCheckBox[studentId] = [];
        }
        cloneUserCheckBox[studentId].isChecked = !cloneUserCheckBox[studentId].isChecked
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    selectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = true
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }
    unselectAllUserFxn = () => {
        let cloneUserCheckBox = lodash.clone(this.state.userCheckBox)
        lodash.each(cloneUserCheckBox, (item) => {
            item.isChecked = false
        })
        this.setState({ userCheckBox: cloneUserCheckBox })
    }

    apiRequest = (params, columns) => {
        return new Promise(async resolve => {

            if (!params.sortField) {
                params.sortField = 'moveDeskDate.moveToClaimDesk'
                params.sortOrder = 'descend'
            }

            if (this.state.counsellorId) {
                params.counsellorId = this.state.counsellorId
                params.page = 1
            }
            if (this.state.studentSearchId) {
                params.studentSearchId = this.state.studentSearchId
                params.page = 1
            } else {
                params.studentSearchId = '';
            }

            if (params.dateOfBirth && params.dateOfBirth.length > 0) {
                var splitDate = params.dateOfBirth[0].split('-');
                const monthNames = ["January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                ];
                var monthName = monthNames[splitDate[1] - 1];

                params.dateOfBirth = splitDate[0] + '-' + monthName + '-' + splitDate[2];

                const stringToDate = new Date(params.dateOfBirth);
                params.dateOfBirth = {
                    $gte: stringToDate.setHours(0, 0, 0),
                    $lt: stringToDate.setHours(23, 59, 59),
                };
            } else {
                delete params.dateOfBirth
            }

            if (this.state.isFollowUpOverdue) {
                params.isFollowUpOverdue = this.state.isFollowUpOverdue;
            }

            if (this.state.time) {
                params.dateFilter = {
                    ...this.state.time,
                    key: 'registrationDesk.registrationDate'
                };
            }
            params.atLevel = ['Submit Fees']
            let data = await Request.loadCounselling({
                ...params,
                ...{
                    isSubmitFee: true,
                },
                regExFilters: ['studentName', 'updatedByUser.name', 'createdByUser.name', 'instituteStudentId']
            })

            delete data.error
            delete data.type

            lodash.each(data.data, (item) => {
                if (!userCheckBox[item._id]) {
                    userCheckBox[item._id] = {
                        _id: item._id,
                        emailId: item.emailId,
                        mobile: item.mobile,
                        studentName: item.studentName,
                        isChecked: false
                    }
                }
            })

            this.setState({ count: data.total, followDuesCount: data.followUpsDuesCount, allBranches: data.allBranches, userCheckBox: userCheckBox })
            resolve(data)
        })
    }

    openPayNow = record => {
        inquiryObj = {
            record: record,
            registrationDesk: record.registrationDesk,
            _id: record._id ? record._id : record.record._id
        }
        this.setState({ showPayNow: true })
    }

    closePayNow = () => {
        this.setState({ showPayNow: false })
        this.table.current.reload()
    }

    // returnDeskName = (val) => {
    //     const deskConfig = Settings.allDesks

    //     let findIn = lodash.find(deskConfig, (rr) => {
    //         return rr.name === val
    //     })

    //     if (findIn) {
    //         return <div style={{
    //             backgroundColor: findIn.color,
    //             color: 'white',
    //             padding: 3,
    //             display: 'inline-block',
    //             fontWeight: 'bold'
    //         }}>{Settings.deskNameObj[val]}</div>
    //     } else {
    //         return <div>{val}</div>
    //     }
    // }

    returnDeskName = (val, _id) => {
        const deskConfig = Settings.allDesks;
        const findIn = lodash.find(deskConfig, rr => rr.name === val);
        const route = deskLinks[val];

        if (findIn && route) {
            return (
                <Link
                    to={`${route}?id=${_id}`}
                    style={{ textDecoration: 'none' }}
                >
                    <span
                        style={{
                            backgroundColor: findIn.color,
                            color: 'white',
                            padding: '3px 6px',
                            display: 'inline-block',
                            fontWeight: 'bold',
                            borderRadius: 4,
                            cursor: 'pointer'
                        }}
                    >
                        {Settings.deskNameObj[val]}
                    </span>
                </Link>
            )
        }
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
        this.loadUserRights();
        this.followUpsCallback = this.followUpsCallback.bind(this);
        Request.getCounsellorsUsers()
            .then(resp => {
                if (resp) {
                    let temp = [{ display: '---Show All---', id: '' }];
                    resp.data = resp.data.reduce((el, vv) => {
                        vv.display = vv.name
                        vv.id = vv._id
                        temp.push(vv)
                        return temp
                    }, []);
                    this.setState({ counsellors: resp.data })
                }
            })
            .catch(err => {
            })
    }

    closeFollowUp = () => {
        this.setState({ showFollowUp: false })
    }
    openFollowUps = record => {
        studentObj = {
            arr: record.followUp,
            name: record.studentName,
            _id: record._id
        };
        this.setState({ showFollowUp: true })
    }

    followUpExtendedDate = (followUp) => {
        if (followUp && followUp.followUpDate) {
            return moment(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')).isAfter(followUp.followUpDate);
        }
    }

    renderStatus = (val) => {
        if (val === 'Ongoing' || val === 'Invoice Processed-Term 1') {
            return <div className={styles.Ongoing}>{val}</div>
        }
        if (val === 'Not Enrolled Yet' || val === 'Invoice Processed-Term 4') {
            return <div className={styles.notEnrolled}>{val}</div>
        }

        if (val === 'Max Commission Paid' || val === 'Invoice Processed-Term 2') {
            return <div className={styles.maxCommission}>{val}</div>
        }

        if (val === 'Withdrawn - Bad Debts' || val === 'Invoice Processed-Term 3') {
            return <div className={styles.withdrawn}>{val}</div>
        }
        if (val === 'To Be Invoiced') {
            return <div className={styles.Invoiced}>{val}</div>
        }
        if (val === 'Invoice Processed-Term 5') {
            return <div className={styles.Term5}>{val}</div>
        }
    }

    componentWillMount() {
        this.setState({ deskColor: Settings.deskColor('Claim Desk') })
    }

    followUpsCallback(isFollowUpOverdue) {
        this.setState({
            isFollowUpOverdue: isFollowUpOverdue,
        }, () => {
            this.table.current.reload()
        });
    }

    chooseRangerPicker = (date) => {
        if (!date || !date.length) {
            this.setState(
                {
                    time: null,
                },
                () => this.table.current.reload()
            );
            return;
        }

        this.setState(
            {
                time: {
                    from: moment(date[0]).startOf('day').toDate(),
                    to: moment(date[1]).endOf('day').toDate(),
                },
            },
            () => this.table.current.reload()
        );
    };

    getRegistrationsDeskData(data) {
        let { registrationsDesk } = data
        const bgBalance = { background: 'red', color: 'white', padding: '10px' };
        let allRegistrationPaymentsHtml = []
        registrationsDesk.map((registration, index) => {
            allRegistrationPaymentsHtml.push(
                <div style={registration.balance ? bgBalance : {}} key={data._id || registration._id || index}>
                    {registration.countryName ? <React.Fragment>Country : {registration.countryName}<br /></React.Fragment> : ""}
                    {registration.total ? <React.Fragment>Total : {registration.total}<br /></React.Fragment> : ""}
                    {registration.paid ? <React.Fragment>Received : {registration.paid}<br /></React.Fragment> : ""}
                    {registration.totalDiscount ? <React.Fragment>Discount : {registration.totalDiscount}<br /></React.Fragment> : ""}
                    {registration.balance ? <React.Fragment>Balance : {registration.balance}<br /></React.Fragment> : ""}
                    {registration.balance ? <React.Fragment>
                        <Button
                            className={styles.btn}
                            onClick={() => this.openPayNow({ ...data, registrationDesk: registration })}
                        >Pay Now</Button>
                    </React.Fragment> : ""}
                </div>
            )
        })
        return allRegistrationPaymentsHtml
    }

    render() {
        const {
            allBranches,
            deskColor,
            paymentBalance,
        } = this.state

        const columns = [
            {
                title: 'ID',
                key: 'id',
                dataIndex: 'id',
                sorter: true,
                width: 80,
                searchTextName: 'Id',
            },
            {
                title: 'Student Name',
                key: 'studentName',
                dataIndex: 'studentName',
                sorter: true,
                searchTextName: 'studentName',
                width: 200,
                render: (text, record) => (
                    <div className={styles.wrap}>
                        <React.Fragment>
                            <div
                                className={
                                    this.followUpExtendedDate(record.followUp ? record.followUp : '') ? styles.followUpExtendedDate : ''
                                }
                            >
                                <Tooltip title="Click To Edit Details">
                                    <a className={styles.btn} target={'_blank'}
                                        href={`/inquiry/studentProfileDetails?id=${record._id}`}
                                    >{text}</a>
                                </Tooltip>
                                <div>{record.mobile}</div>

                                <div>
                                    {record.watsupp && record.watsupp.length === 10 ?
                                        <Tooltip title="Share on Whatsapp">
                                            <a target={'_blank'}
                                                style={{ textDecoration: 'underline' }}
                                                href={`http://api.whatsapp.com/send?phone=91${record.watsupp}&text=&source=&data=`}>{record.watsupp}</a>
                                        </Tooltip>
                                        : record.watsupp}

                                </div>
                                <div>{record.emailId}</div>
                            </div>
                        </React.Fragment>
                    </div>
                )
            },
            {
                title: 'Payment Details',
                key: 'registrationDesk',
                dataIndex: 'registrationDesk',
                width: 120,
                filters: paymentBalance && paymentBalance.map(x => ({ value: x.value, text: x.label })),
                filterMultiple: false,
                render: (item, record) => {
                    const bgBalance = { background: 'red', color: 'white', padding: '10px' };
                    return (
                        <div key={record._id}>

                            {
                                record.registrationsDesk && record.registrationsDesk.length > 0 ?
                                    this.getRegistrationsDeskData(record)
                                    :
                                    <div style={item.balance ? bgBalance : {}}>
                                        {item.total ? <React.Fragment>Total : {item.total}<br /></React.Fragment> : ''}
                                        {item.paid ? <React.Fragment>Received : {item.paid}<br /></React.Fragment> : ''}
                                        {item.totalDiscount ? <React.Fragment>Discount : {item.totalDiscount}<br /></React.Fragment> : ''}
                                        {item.balance ? <React.Fragment>Balance : {item.balance}<br /></React.Fragment> : ''}
                                        {item.balance ? <React.Fragment>
                                            <Button
                                                className={styles.btn}
                                                onClick={() => this.openPayNow(record)}
                                            >Pay Now</Button>
                                        </React.Fragment> : ''}
                                    </div>
                            }
                        </div>
                    )
                }
            },
            {
                title: 'DOB ',
                width: 100,
                key: 'dateOfBirth',
                dataIndex: 'dateOfBirth',
                render: (val, record) => {
                    return (
                        <div>
                            {record.dateOfBirth
                                ? moment(record.dateOfBirth).format(dateFormat)
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Registration Date',
                width: 180,
                sorter: true,
                key: 'registrationDesk.registrationDate',
                render: (val, record) => {
                    return (
                        <div>
                            {record.registrationDesk && record.registrationDesk.registrationDate
                                ? moment(record.registrationDesk.registrationDate).format(dateFormat)
                                : ''}
                        </div>
                    )
                }
            },
            {
                title: 'Course/University',
                key: 'selectedCourse',
                width: 250,
                dataIndex: 'visaDesk.selectedCourse',
                render: (text, record) => {
                    return (<div>
                        <div>{text ? text.courseName : ''}{text ? text.campusName ? `(${text.campusName})` : '' : ''}</div>
                        <div>{text ? text.universityInstitutionName : ''}</div>
                    </div>)
                }
            },
            {
                title: 'Follow Up',
                key: 'followUp.followUpDate',
                width: 200,
                dataIndex: 'followUp',
                render: (text, record) => {
                    return <LatestFollowUp info={text} />
                }
            },
            {
                title: 'At Stage',
                key: 'atStage',
                width: 150,
                filters: [
                    { value: 'Application Desk', text: 'Application Desk' },
                    { value: 'Visa Desk', text: 'Visa Desk' },
                    { value: 'Claim Desk', text: 'Claim Desk' }
                ],
                render: (val, record) => {
                    return (
                        this.returnDeskName(record.atLevel, record._id)
                    )
                }
            },
            {
                title: 'Branch',
                key: 'studentBranchId',
                filters: allBranches,
                width: 100,
                render: (text, record) => {
                    return (
                        <div>
                            {record.studentBranchId ? record.studentBranchId.branchName : ''}
                        </div>
                    )
                }
            },
        ];
        return (

            <PageHeaderWrapper deskColor={deskColor} title={`Submit Fees : ${this.state.count} `}>
                {this.state.showFollowUp ? (
                    <ListFollowUps studentObj={studentObj} onClose={this.closeFollowUp} />
                ) : null}

                {this.state.showPayNow ? (
                    <Payment inquiryObj={inquiryObj} onClose={this.closePayNow} />
                ) : null}
                {this.state.showWhatsAppSms ? (
                    <WhatsAPPSMS counsellingData={counsellingData} onClose={this.closeWhatsSMS} />
                ) : null}

                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer counsellingData={counsellingData} onClose={this.closeEmail} />
                ) : null}
                <Card bordered={true}>
                    <Row>
                        <Col span={8}>
                            <label>Search By Registration Date</label><br />
                            <RangePicker
                                format="YYYY-MM-DD"
                                placeholder={['Start Date', 'End Date']}
                                onChange={this.chooseRangerPicker}
                                onOk={this.onOk}
                            />
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        ref={this.table}
                        id={'submitfee'}
                        get che
                        apiRequest={this.apiRequest}
                        extraProps={{ scroll: { x: 1000 } }}
                        pagination={{
                            showSizeChanger: true,
                            defaultPageSize: 20,
                            pageSizeOptions: ['10', '20', '50', '100', '1000']
                        }}
                    />
                </Card>
            </PageHeaderWrapper>

        )
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubmitFees)
